/* eslint-disable arrow-body-style */
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { FormProvider, RHFTextField, RHFUploadSingleFile } from 'src/components/hook-form';
import { useForm } from 'react-hook-form';
import { Item, ItemTypesEnum, VideoItem } from 'src/@types/Course';
import {
  Video_DocumentItemDefaultValues,
  Video_DocumentItemSchema,
  uploadFiles,
} from './components/sectionItemsSchemas';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { AssetsSection } from './components/AssetsSection';
import { StyledFormBox } from './components/styles';
import DetailsSection from './components/DetailsSection';
import TextMaxLine from 'src/components/TextMaxLine';
// ----------------------------------------------------------------------

export default function VideoItemForm({
  onSubmit,
  currentItem,
}: {
  onSubmit(data: Item): void;
  currentItem: Item | undefined;
}) {
  const methods = useForm({
    resolver: yupResolver(Video_DocumentItemSchema),
    defaultValues: Video_DocumentItemDefaultValues,
  });
  const {
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { isSubmitting },
  } = methods;
  const values = watch();
  const updateDefaultValues = () => {
    return {
      assets: currentItem?.assets || [],
      title: currentItem?.title || '',
      title_ar: currentItem?.title_ar || '',
      details: currentItem?.details || {
        type: ItemTypesEnum.VIDEO,
      },
      url: currentItem?.url || '',
      order: currentItem?.order || 0,
      description: currentItem?.description || '',
      description_ar: currentItem?.description_ar || '',
      duration: currentItem?.duration || 0,
      points: currentItem?.points || 0,
      isFreeToWatch: currentItem?.isFreeToWatch || false,
    } as Item;
  };
  useEffect(() => {
    if (currentItem) {
      reset(updateDefaultValues());
    }
    if (!currentItem) {
      reset(Video_DocumentItemDefaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItem]);

  return (
    <Stack height={'100%'} sx={{ overflow: 'auto' }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack direction={'column'} justifyContent={'space-between'} height={'100%'}>
          <StyledFormBox
            sx={{
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
            }}
          >
            <DetailsSection isFree={values.isFreeToWatch} setIsFree={(val) => {
                setValue('isFreeToWatch',val)
            }} />
            <TextMaxLine
              sx={{
                fontSize: '18px',
                paddingBottom: '10px',
                fontWeight: '700',
              }}
            >
              Paste Video Url{' '}
            </TextMaxLine>
           
            <RHFTextField name="url" label="url" />

            <AssetsSection assets={values?.assets??[]} setValue={setValue} />
          </StyledFormBox>
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton
              style={{ width: '200px', height: '50px' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {'Save '}
            </LoadingButton>
          </Stack>
        </Stack>
      </FormProvider>
    </Stack>
  );
}
